var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { createAction } from "typesafe-actions";
import { postAnswer } from "../../services/answerService";
import * as feedbackDisplayedActions from "../feedbackDisplayed/actions";
import * as userActions from "../user/actions";
import * as quizActions from "../quiz/actions";
import * as messageActions from "../message/actions";
import { wordCount } from "../../utils/string_tools";
export var setAnswer = createAction("quizAnswer/SET", function (resolve) {
  return function (payload) {
    return resolve(payload);
  };
});
export var setAnswerFormatIsValid = createAction("quizAnswer/ANSWER_FORMAT_IS_VALID", function (resolve) {
  return function (payload) {
    return resolve(payload);
  };
});
export var setQuizDisabled = createAction("quizAnswer/SET_QUIZ_DISABLED", function (resolve) {
  return function (newValue) {
    return resolve(newValue);
  };
});
export var clear = createAction("quizAnswer/CLEAR");
export var setNoChangesSinceSuccessfulSubmit = createAction("quizAnswer/SET_NO_CHANGES_SINCE_SUCCESSFUL_SUBMIT");
export var setLocked = createAction("quizAnswer/SET_LOCKED");
export var setUnlocked = createAction("quizAnswer/SET_UNLOCKED");
export var pastDeadline = createAction("quizAnswer/PAST_DEADLINE");
export var setAttemptedSubmit = createAction("quizAnswer/ATTEMPT_DISABLED_SUBMIT", function (resolve) {
  return function () {
    return resolve();
  };
});
export var clearAttemptedSubmit = createAction("quizAnswer/CLEAR_DISABLED_SUBMIT");
export var changeTextDataAction = createAction("quizAnswer/UPDATE_TEXT_VALUE", function (resolve) {
  return function (itemId, newValue, readyToSubmit) {
    return resolve({
      itemId: itemId,
      newValue: newValue,
      readyToSubmit: readyToSubmit
    });
  };
});
export var changeIntDataAction = createAction("quizAnswer/UPDATE_INT_VALUE", function (resolve) {
  return function (itemId, newValue) {
    return resolve({
      itemId: itemId,
      newValue: newValue
    });
  };
});
export var changeCheckboxDataAction = createAction("quizAnswer/TOGGLE_CHECKBOX_VALUE", function (resolve) {
  return function (itemId, optionId) {
    return resolve({
      itemId: itemId,
      optionId: optionId
    });
  };
});
export var chooseOptionAction = createAction("quizAnswer/CHOOSE_OPTION", function (resolve) {
  return function (itemId, optionId, multi) {
    return resolve({
      itemId: itemId,
      optionId: optionId,
      multi: multi
    });
  };
});
export var chooseOption = function chooseOption(itemId, optionId, multi) {
  return function (dispatch, getState) {
    dispatch(chooseOptionAction(itemId, optionId, multi));
  };
};
export var changeChosenOption = function changeChosenOption(itemId, optionId) {
  return function (dispatch, getState) {
    var _a;
    var item = (_a = getState().quiz) === null || _a === void 0 ? void 0 : _a.items.find(function (i) {
      return i.id === itemId;
    });
    if (!item) {
      return;
    }
    var multi = item.multi;
    dispatch(feedbackDisplayedActions.hide());
    dispatch(chooseOption(itemId, optionId, multi));
  };
};
export var changeCheckboxData = function changeCheckboxData(itemId, optionId) {
  return function (dispatch, getState) {
    dispatch(changeCheckboxDataAction(itemId, optionId));
  };
};
export var noticeDisabledSubmitAttempt = function noticeDisabledSubmitAttempt() {
  return function (dispatch, getState) {
    dispatch(setAttemptedSubmit());
    setTimeout(function () {
      return dispatch(clearAttemptedSubmit());
    }, 5000);
  };
};
export var changeIntData = function changeIntData(itemId, newValue) {
  return function (dispatch, getState) {
    dispatch(changeIntDataAction(itemId, newValue));
  };
};
export var changeTextData = function changeTextData(itemId, newValue) {
  return function (dispatch, getState) {
    var _a;
    var item = (_a = getState().quiz) === null || _a === void 0 ? void 0 : _a.items.find(function (i) {
      return i.id === itemId;
    });
    if (item === undefined) {
      return;
    }
    dispatch(feedbackDisplayedActions.hide());
    var readyToSubmit = itemAnswerReadyForSubmit(newValue, item);
    dispatch(changeTextDataAction(itemId, newValue, readyToSubmit));
  };
};
export var submit = function submit() {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a, quiz, quizAnswer, userQuizState, languageInfo, error_1, languageLabels;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            dispatch(setLocked());
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            return [4, postAnswer(getState().quizAnswer.quizAnswer, getState().user.accessToken, getState().backendAddress)];
          case 2:
            _a = _b.sent(), quiz = _a.quiz, quizAnswer = _a.quizAnswer, userQuizState = _a.userQuizState;
            if (!quiz) {
              quiz = getState().quiz;
            }
            dispatch(userActions.setUserQuizState(userQuizState));
            dispatch(setNoChangesSinceSuccessfulSubmit());
            if (userQuizState.status === "locked") {
              dispatch(quizActions.set(quiz));
              dispatch(setAnswer(quizAnswer));
              dispatch(feedbackDisplayedActions.display());
            } else if (userQuizState.pointsAwarded && Math.abs(userQuizState.pointsAwarded - quiz.points) < 0.001) {
              dispatch(quizActions.set(quiz));
              dispatch(setAnswer(quizAnswer));
              dispatch(feedbackDisplayedActions.display());
            } else {
              languageInfo = getState().language.languageLabels;
              if (languageInfo) {
                dispatch(messageActions.notifyUser(languageInfo.general.incorrectSubmitWhileTriesLeftLabel));
              }
            }
            return [3, 4];
          case 3:
            error_1 = _b.sent();
            languageLabels = getState().language.languageLabels;
            dispatch(messageActions.errorOccurred(languageLabels && languageLabels.error.submitFailedError || "could not submit answer"));
            return [3, 4];
          case 4:
            return [2];
        }
      });
    });
  };
};
var itemAnswerReadyForSubmit = function itemAnswerReadyForSubmit(textData, item) {
  if (!item) {
    return false;
  }
  if (!textData) return false;
  var words = wordCount(textData);
  if (item.minWords && words < item.minWords) return false;
  if (item.maxWords && words > item.maxWords) return false;
  return true;
};